import React from "react";
import { stores, storesContext } from "./index";

export const useStores = () => React.useContext(storesContext);


export const useStore = (key) =>  useStores()[key];
